import { useQuery } from '@tanstack/react-query';
import { getSbpPaymentType } from '@/shared/api';
import { DEFAULT_RETRY_COUNT } from '@/shared/config';
import type {
  SbpOperationDirection,
  SbpPaymentTypeResponse,
} from '@/shared/types';

interface UseSbpPaymentTypeOptions {
  direction: SbpOperationDirection;
  currencyCode: string;
  enabled?: boolean;
}

export function useSbpPaymentType({
  direction,
  currencyCode,
  enabled = true,
}: UseSbpPaymentTypeOptions) {
  const query = useQuery<SbpPaymentTypeResponse, Error>({
    queryKey: [`sbp-${direction}-paymentType`, currencyCode],
    queryFn: () => getSbpPaymentType(direction, currencyCode),
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: DEFAULT_RETRY_COUNT,
  });

  const paymentTypeCode = query.data?.paymentTypeCode || '';
  const isEmptyPaymentType = !!query.data && !paymentTypeCode;

  return {
    paymentTypeCode,
    isPaymentTypeLoading: query.isLoading,
    isPaymentTypeFetching: query.isFetching,
    isPaymentTypeError: query.isError || isEmptyPaymentType,
    paymentTypeError:
      query.error ??
      (isEmptyPaymentType ? new Error('common.unknownError') : null),
  };
}
